import React from 'react';

const BlogDetails = ({blog}) => {
    const bodyStyle={
        width: "17rem"
    }
    return (
        <div className="mt-5 col-md-4 col-sm-12">
            <div class="card" style={bodyStyle} >
                <img src={blog.photo} className="card-img-top blogPhoto" alt="photoss"/>
                <div className="card-body">
                    <h5 className="card-title">{blog.headline}</h5>
                    <p className="card-text">{blog.body}</p>
                    <a href={blog.link} target="_blank" rel="noreferrer"  className="btn btn-primary">Read more</a>
                </div>
            </div>
        </div>
    );
};

export default BlogDetails;